import { useEffect, useState } from "react";
import { getEncryptedBody, getDecryptedData } from "../utils/common";
import { toast } from "react-toastify";

interface UseInitialCycleDataV2Props {
  patientId?: string;
  visitId?: string;
  cycleType: "first" | "upcoming"; // Distinguish between first cycle and upcoming cycle
  enabled?: boolean; // Control when to call the API
}

const useInitialCycleDataV2 = ({
  patientId,
  visitId,
  cycleType,
  enabled = true,
}: UseInitialCycleDataV2Props) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled || !patientId) {
      return;
    }

    const fetchInitialData = async () => {
      setLoading(true);
      setError(null);

      try {
        const token = localStorage.getItem("token");
        const secretKey = process.env.REACT_APP_HEALTH_SECRET_KEY!;

        // Build the request body based on cycle type
        const body: any = {
          patient_id: patientId,
          cycle_type: cycleType,
        };

        // Add visit_id for upcoming cycle
        if (cycleType === "upcoming" && visitId) {
          body.visit_id = visitId;
        }

        console.log(`V2 Initial ${cycleType} Cycle Data Request:`, body);

        const encryptedBody = getEncryptedBody(body);

        // Therapy drugs API for dropdown options
        const TherapyDrugsAPI = `${process.env.REACT_APP_API_URL}/api/v8/healthcoach/therapy_drugs`;

        console.log("TherapyDrugsAPI", TherapyDrugsAPI);
        const response = await fetch(TherapyDrugsAPI, {
          method: "GET",
          headers: {
            "Content-Type": "text/plain",
            token: `${token}`,
            health_secret: secretKey,
          },
          //body: `${encryptedBody}`,
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch ${cycleType} cycle initial data`);
        }

        const responseData = await response.json();
        console.log("responseData", responseData);
        const decryptedData = getDecryptedData(responseData);
        
        console.log(`V2 Initial ${cycleType} Cycle Data Response:`, decryptedData);

        // Parse if it's a string
        // const parsedData = typeof decryptedData === "string" 
        //   ? JSON.parse(decryptedData) 
        //   : decryptedData;

        setData(decryptedData);
        setLoading(false);
      } catch (err: any) {
        console.error(`Error fetching ${cycleType} cycle initial data:`, err);
        setError(err.message || "Failed to fetch initial data");
        toast.error(`Failed to load ${cycleType} cycle data`);
        setLoading(false);
      }
    };

    fetchInitialData();
  }, [patientId, visitId, cycleType, enabled]);

  return {
    loading,
    data,
    error,
    refetch: () => {
      // Trigger refetch by updating a dependency
      setLoading(true);
    },
  };
};

export default useInitialCycleDataV2;
